import React from 'react';
import cls from '@utils/css-select'
import styles from './styles.scss';
import EmptyTable from '../empty-table/main';
import { MainOrderItem } from 'pages/offical/personal/const';
import { moneyThousand } from '@utils/moneyFormat';
import { PayButton } from 'pages/offical/personal/components/table-pc/main';
import AcIcon from 'ac-components/ac-icon';
const cx = cls(styles)
type RecordTableProps = {
	record?: MainOrderItem[];
	transData?: any;
}

function RecordTableM(props: RecordTableProps) {
	const { record = [], transData } = props

	return (
		<>
			{record.length ? <div className={cx('record-table_m')}>
				{
					record.map(item => (
						<div className={cx('record-table_row')} key={item.orderNo}>
							<div className={cx('pay-status-icon', { 'success': item.orderStatus === '2' })}>
								<AcIcon
									color={item.orderStatus === '2' ? '#52c51a' : '#ffd022'}
									icon={cx({
										'icon_progress_underway': item.orderStatus === '0' || item.orderStatus === '1', // 待支付
										'a-icon_progressdone': item.orderStatus === '2' // 已支付
									})} />
							</div>
							<ul className={cx('record-item_main')}>
								<li>
									<p className={cx('label')}>{transData.date}</p>
									<p className={cx('value')}>{item.orderTime}</p>
								</li>
								<li>
									<p className={cx('label')}>{transData.orderContent}</p>
									<p className={cx('value')}>{item.orderContent}</p>
								</li>
								<li>
									<p className={cx('label')}>{transData.orderNumber}</p>
									<p className={cx('value')}>{item.orderNo}</p>
								</li>
								<li className={cx('price-pay')}>
									<div>
										<p className={cx('label')}>{transData.orderPrice}</p>
										<p className={cx('value', 'price')}>{`${item.paymentCurrency || 'RMB'}${moneyThousand(item.orderAmount)}`}</p>
									</div>
									<div className={cx('action')}>
										{
											!(item.subList?.length) && (item.orderStatus === '0' || item.orderStatus === '1') ?
												<PayButton orderNo={item.orderNo} orderPaymentNo='' /> : ''
										}
									</div>
								</li>
							</ul>
							{
								item.subList?.length ? (<ul className={cx('record-item_sub')}>
									{
										item.subList.map(subItem => (
											<li className={cx('price-pay')} key={subItem.subOutTradeNo}>
												<div>
													<p className={cx('label')}>{transData.subOrder}</p>
													<p className={cx('value', 'price')}>{`${item.paymentCurrency || 'RMB'}${moneyThousand(subItem.payAmount)}`}</p>
												</div>
												<div className={cx('action')}>
													{subItem.canPaid ? <PayButton orderNo={item.orderNo} orderPaymentNo={subItem.subOutTradeNo} /> : ''}
												</div>
											</li>
										))
									}
								</ul>) : ''
							}
						</div>
					))
				}
			</div> : EmptyTable()}
		</>
	)
}

export default RecordTableM
